module.exports = __webpack_public_path__ + "img/ai-chentu.e4d9cc5c.png";